import { Component, Input, ViewChild, ElementRef, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MentionModule } from 'angular-mentions';

export type ButtonSize = 'small' | 'medium' | 'large';

@Component({
  selector: 'app-textarea',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MentionModule,
  ],
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
})
export class TextareaComponent implements OnChanges {
  @ViewChild('textarea', { static: false })
  textarea!: ElementRef<HTMLTextAreaElement>;

  @Input() size: ButtonSize = 'medium';
  @Input() readOnly: boolean = false;
  @Input() highlight: boolean = false;
  @Input() initialValue?: any;
  @Input() placeholder?: string;
  @Input() label?: string;
  @Input() id?: string;
  @Input() control?: FormControl;
  @Input() shouldFocus: boolean = false;
  @Input() mentionData: string[] = [];
  @Input() rows: number = 2;

  @Output() focused = new EventEmitter<void>();

  public mentionConfig = {
    items: [] as string[],
    triggerChar: '@' as string,
    labelKey: undefined as string | undefined,
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (this.shouldFocus) {
      this.focus();
    }
    if (changes['mentionData']) {
      this.mentionConfig = {
        ...this.mentionConfig,
        items: this.mentionData
      };
    }
  }

  onFocus(): void {
    this.highlight = true;
    this.focused.emit();
  }

  private focus(): void {
    setTimeout(() => this.textarea?.nativeElement?.focus());
  }
}
